export const UPDATE_MYLICENCE_DATA = 'src/RiskCollection/UPDATE_MYLICENCE_DATA'

export const REQUEST_MYLICENCE_STATUS = 'src/MyLicence/REQUEST_MYLICENCE_STATUS'
export const REQUEST_MYLICENCE_STATUS_SUCCESS =
  'src/MyLicence/REQUEST_MYLICENCE_STATUS_SUCCESS'

export const REQUEST_MYLICENCE_STATUS_REL = 'GetMyLicenceStatus'
